<div class="topbar-item nav-user">
    <div ngbDropdown [placement]="'bottom-end'" class="dropdown">
        <button ngbDropdownToggle class="btn btn-link p-0 topbar-link dropdown-toggle drop-arrow-none px-2">
            <!-- <img src="" width="32" class="rounded-circle me-lg-2 d-flex"
                 alt="user-image"> -->
            <div class="d-lg-flex align-items-center gap-1 d-none">
                <h5 class="my-0">{{ username }}</h5>
                <span class="d-flex align-middle"><ng-icon name="tablerChevronDown"/></span>
            </div>
        </button>
        <div ngbDropdownMenu class="dropdown-menu dropdown-menu-end">
             <div ngbDropdownMenu class="dropdown-menu dropdown-menu-end mt-1">
                <div class="dropdown-header noti-title">
                </div>

                <a class="dropdown-item" (click)="openNewPassword()">
                    <ng-icon
                        name="tablerSettings2"
                        size="17"
                        class="align-middle d-inline-flex align-items-center me-2"
                    ></ng-icon>
                    <span class="align-middle">{{'DROPDOWNMENU_PROFILE_NEW_PASS' | translate}}</span>
                </a>

                <a
                    class="dropdown-item text-danger fw-semibold"
                    (click)="onLogout()"
                >
                    <ng-icon
                        name="tablerLogout2"
                        size="17"
                        class="align-middle d-inline-flex align-items-center me-2"
                    ></ng-icon>
                    <span class="align-middle">{{'DROPDOWNMENU_PROFILE_LOGOUT' | translate}}</span>
                </a>
            </div>
        </div>

    </div>
</div>
